import React from 'react';
import EngagementCard from './components/EngagementIndex.jsx';

const Engagement = () => <EngagementCard />;

export default Engagement;
